/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
export var NotificationMainType = {
  UN_CLASSIFIED: 0,
  TARGET_PLAN: 1,
  INVITATION: 2,
  CREATOR_STOCK: 3,
  CREATOR_IM: 4,
  IM_NEW_MESSAGE: 5,
  IM_MESSAGING: 6,
  AGENCY_IM: 7
};
export var NotificationSubType = {
  DEFAULT: 0,
  FREE_SAMPLE: 1,
  SYSTEM: 2,
  DIRECT_INVITES: 3,
  CREATOR_STOCK_TYPE: 4
};
export var NotificationMiddleType = {
  TITLE_ONLY: 1,
  NAME_CONTENT_TIME: 2,
  TITLE_CONTENT_TIME: 3
};
export var NotificationRightType = {
  NOTHING: 1,
  ARROW: 2,
  BUTTON: 3,
  IMAGE: 4
};
export var NotificationClassification = {
  CLASSIFICATION_CREATOR_STOCK: 1
};
export var CreatorConversationType = {
  ALL: 0,
  MESSAGING: 1,
  NEW_MESSAGE: 2
};
export var NotificationGroup = {
  ALL_GROUP: 0,
  COOPERATION: 1,
  PRODUCTS: 2,
  GOVERNANCE: 3,
  ANNOUNCEMENT: 4,
  PROMOS: 5,
  SAMPLE_MANAGEMENT: 6
};
export var NotificationScene = {
  INVALID_SCENE: 0,
  EXCLUSIVE_STOCK: 1,
  PLATFORM_ACTIVITY: 2
};
export var RemindLevel = {
  STRONG: 1,
  NORMAL: 2,
  WEAK: 3
};
export var IMUserRole = {
  CREATOR: 1,
  SELLER: 2
};
export var IMRelationType = {
  BLOCK: 1,
  UNBLOCK: 2
};
export var QuotaType = {
  Week: 1
};
export var RuleVersion = {
  Version_No_Limit: 1,
  Version_Week_GMV: 2
};
export var ShopIMEntranceStatus = {
  UnKnown: 0,
  Normal: 1,
  CreatorCleared: 2,
  ShopBlock: 3,
  CreatorBlock: 4,
  Banned: 5,
  QuotaLimited: 6,
  FollowerLimited: 7,
  NotAuthorized2NonEUSeller: 8,
  CreatorBlockByGovernance: 9
};
export var IMEntranceType = {
  CreateConversation: 1,
  SendMsgDoCreateConversation: 2
};
export var IMPermissionStatus = {
  PermissionUnKnown: 0,
  PermissionNormal: 1,
  PermissionAbnormal: 2
};
export var ReceiveEcMarketingPush = {
  NotAllowPush: 0,
  AllowPush: 1
};
export var ShopLevel = {
  Low_Level_Shop: 1,
  Mid_Level_Shop: 2,
  High_Level_Shop: 3,
  Shop_Level_4: 4,
  Shop_Level_5: 5,
  Shop_Level_6: 6,
  Shop_Level_7: 7,
  Shop_Level_8: 8,
  Shop_Level_9: 9
};